export enum BonusCodeState {
  Available = 1,
  Reserved,
  Used,
  Expired,
  Voided,
}

export enum BonusCodeType {
  ViewFixed = 1,
  ClickFixed,
  ViewPercent,
  ClickPercent,
  ClickAndViewPercent,
  PriceDiscount,
}

export enum BonusCodeCondition {
  None = 0,
  Firsttime,
  PriceThreshold,
  TimePeriod,
}

export type ApiBonusCodeRecord = {
  id: string;
  code: string;
  discount_celling: number;
  type: BonusCodeType;
  value: number;
  ad_id: string;
  state: BonusCodeState;
  exp_date: string;
  condition: BonusCodeCondition;
  price_threshold: number;
  time_period_start: string;
  time_period_end: string;
};
